<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
      <div class="flex items-center pt-6">
        <button @click="openAddModal" class="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md">Aggiungi contatto</button>
      </div>
    </div>
    <div class="p-6 pb-0">
      <PageServerTable
        :headers="headers"
        :items="contacts"
        :items-per-page.sync="ipp"
        :items-per-page-options="ippo"
        :sort-by="sortby"
        :items-length="contactsCount"
        :reload-fn="reload"
        :item-value="'id'"
        :page="page"
        show-current-page
      >
        <template #item.role="{ item }">
          <span>{{ item.role ? item.role : '-' }}</span>
        </template>
        <template #item.actions="{ item }">
          <button @click="openEditModal(item)" class="bg-yellow-500 text-white px-2 py-1 rounded-md mr-2">Modifica</button>
          <button @click="openDeleteModal(item)" class="bg-red-500 text-white px-2 py-1 rounded-md">Elimina</button>
        </template>
      </PageServerTable>
    </div>

    <!-- Modale per aggiungere/modificare -->
    <div v-if="showModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="closeModal">
      <div class="bg-white p-6 rounded-md w-full max-w-md" @mousedown.stop>
        <h2 class="text-xl mb-4">{{ isEditing ? 'Modifica' : 'Aggiungi' }} contatto</h2>
        <form @submit.prevent="isEditing ? update() : add()">
          <div class="mb-4">
            <label class="block text-gray-700">Nome</label>
            <input v-model="form.name" type="text" class="p93__input" required>
            <div v-if="form.errors.name" class="text-red-500 text-sm pt-2">{{ form.errors.name }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Email</label>
            <input v-model="form.email" type="text" class="p93__input" required>
            <div v-if="form.errors.email" class="text-red-500 text-sm pt-2">{{ form.errors.email }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Telefono</label>
            <input v-model="form.phone" type="text" class="p93__input" required>
            <div v-if="form.errors.phone" class="text-red-500 text-sm pt-2">{{ form.errors.phone }}</div>
          </div>
          <div class="mb-4">
            <label class="block text-gray-700">Ruolo</label>
            <input v-model="form.role" type="text" class="p93__input">
            <div v-if="form.errors.role" class="text-red-500 text-sm pt-2">{{ form.errors.role }}</div>
          </div>
          <div class="flex justify-end">
            <button type="button" @click="closeModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
            <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded-md">{{ isEditing ? 'Aggiorna' : 'Aggiungi' }}</button>
          </div>
          <input type="hidden" v-model="form.id">
        </form>
      </div>
    </div>

    <!-- Modale di conferma eliminazione -->
    <div v-if="showDeleteModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @click="closeDeleteModal">
      <div class="bg-white p-6 rounded-md w-full max-w-md" @click.stop>
        <h2 class="text-xl mb-4">Conferma Eliminazione</h2>
        <p>Sei sicuro di voler eliminare  {{ itemToDelete.name }}?</p>
        <div class="flex justify-end mt-4">
          <button @click="closeDeleteModal" class="bg-gray-500 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
          <button @click="deleteItem" class="bg-red-500 text-white px-4 py-2 rounded-md">Elimina</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, useForm, router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Datepicker from 'vue3-datepicker';
import PageServerTable from '@/Components/PageServerTable.vue';

export default {
  props: ['contacts', 'contactsCount', 'errors'],
  components: {
    Link,
    BreadCrumbs,
    Datepicker,
    PageServerTable
  },
  data() {
    return {
      headers: [],
      sortby: [],
      ipp: 5,
      ippo: [
        { value: 5, title: '5' },
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' }
      ],
      page: 1,
      showModal: false,
      showDeleteModal: false,
      isEditing: false,
      form: useForm({
        id: null,
        name: '',
        email: '',
        phone: '',
        role: ''
      }),
      itemToDelete: null,
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.reception-digitale'), href: route('modules.home', 'reception-digitale') },
        { name: 'Contatti', href: route('modules.rd-gestione-contatti') }
      ]
    };
  },
  mounted() {
    this.headers = this.$attrs.headers;
    this.sortby = this.$attrs.sortby;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined) {
      if (sortby) this.sortby = sortby;
      if (itemsperpage) this.ipp = itemsperpage;
      if (page) this.page = page;
      router.post(window.location.href, {
        headers: this.headers,
        sortby: this.sortby,
        itemsperpage: this.ipp,
        page: this.page
      }, { only: ['contacts', 'contactsCount'] });
    },
    openAddModal() {
      this.form.clearErrors();
      this.form.id = null;
      this.form.name = null;
      this.form.email = null;
      this.form.phone = null;
      this.form.role = null;
      this.isEditing = false;
      this.showModal = true;
    },
    openEditModal(item) {
      this.form.reset();
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.email = item.email;
      this.form.phone = item.phone;
      this.form.role = item.role;
      this.isEditing = true;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    add() {
      this.form.post(route('modules.rd-aggiungi-contatto'), {
        onSuccess: () => this.closeModal()
      });
    },
    update() {
      this.form.post(route('modules.rd-modifica-contatto'), {
        onSuccess: () => this.closeModal()
      });
    },
    openDeleteModal(item) {
      this.itemToDelete = item;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    deleteItem() {
      this.form.delete(route('modules.rd-elimina-contatto', this.itemToDelete.id), {
        onSuccess: () => this.closeDeleteModal()
      });
    }
  }
};
</script>